<payments-modal [title]="'common.selectRole' | translate">
  <ng-container content>
    <mat-form-field appearance="fill" class="w-full" hideRequiredMarker>
      <input
        matInput
        type="text"
        [placeholder]="'common.selectOrganization' | translate"
        [attr.aria-label]="'common.selectOrganization' | translate"
        [matAutocomplete]="companyAuto"
        [formControl]="companiesControl"
        [errorStateMatcher]="errorStateMatcher" />
      @if (hasCompany()) {
        <button mat-icon-button matSuffix (click)="clearCompany()" [attr.aria-label]="'common.clear' | translate">
          <mat-icon>clear</mat-icon>
        </button>
      } @else {
        <mat-icon matSuffix class="pointer-events-none">arrow_drop_down</mat-icon>
      }

      <mat-autocomplete #companyAuto="matAutocomplete" [displayWith]="displayCompany">
        @for (company of filteredCompanies$ | async; track $index) {
          <mat-option [value]="company">
            {{ company.name }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (companiesControl.hasError('invalidSelection')) {
        <mat-error>
          {{ 'validationErrors.invalidSelection' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill" class="w-full" hideRequiredMarker>
      <input
        matInput
        type="text"
        [placeholder]="'common.selectRolePlaceholder' | translate"
        [attr.aria-label]="'common.selectRolePlaceholder' | translate"
        [matAutocomplete]="roleAuto"
        [formControl]="rolesControl"
        [errorStateMatcher]="errorStateMatcher" />
      @if (hasRole()) {
        <button mat-icon-button matSuffix (click)="clearRole()" [attr.aria-label]="'common.clear' | translate">
          <mat-icon>clear</mat-icon>
        </button>
      } @else {
        <mat-icon matSuffix class="pointer-events-none">arrow_drop_down</mat-icon>
      }

      <mat-autocomplete #roleAuto="matAutocomplete" [displayWith]="displayRole">
        @for (role of filteredRoles$ | async; track $index) {
          <mat-option [value]="role">
            {{ role.roleName }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (rolesControl.hasError('invalidSelection')) {
        <mat-error>
          {{ 'validationErrors.invalidSelection' | translate }}
        </mat-error>
      }
    </mat-form-field>
  </ng-container>

  <ng-container actions>
    <payments-form-discard-with-confirmation [form]="rolesControl" (confirm)="close()">
    </payments-form-discard-with-confirmation>

    <button mat-raised-button (click)="submit()" cdkFocusInitial color="primary" class="action" [loading]="loading">
      {{ 'common.useRole' | translate }}
    </button>
  </ng-container>
</payments-modal>
